// extracted by mini-css-extract-plugin
export var closeButton = "_82-0";